<ng-content>
</ng-content>
<div *ngIf="translationKey && translationKey.length > 0">
    {{ translationKey | translate: translationValues }}
</div>
